import { formatDate, formatDateForInput } from '@/utils/dateFormatter';
import { VueEditor } from 'vue2-editor';
import ImageCropper from '@/components/ImageCropper.vue';

export default {
  name: "Competency",
  components: {
    VueEditor,
    ImageCropper
  },
  computed: {
    competencyData() {
      return this.$store.getters["competency/getCompetencies"] || [];
    },
    totalItems() {
      return this.$store.getters["competency/getTotalItems"] || 0;
    },
    isLoading() {
      return this.$store.getters["competency/getLoading"];
    },
    competencyOptions() {
      return this.$store.getters["competencyOptions/getCompetencyOptions"] || [];
    },
    isLoadingCompetencyOptions() {
      return this.$store.getters["competencyOptions/getLoading"] || false;
    },
    positionOptions() {
      return this.$store.getters["position/getPositions"] || [];
    },
    isLoadingPositionOptions() {
      return this.$store.getters["position/getLoading"] || false;
    },
    roleCompetencyOptions() {
      return this.$store.getters["roleCompetency/getRoleCompetencies"] || [];
    },
    isLoadingRoleCompetencyOptions() {
      return this.$store.getters["roleCompetency/getLoading"] || false;
    },
    competencyDetailData() {
      return this.$store.getters["competency/getCompetencyDetail"] || {};
    },
    formattedPositionProficiencyData() {
      const detailData = this.competencyDetailData.id ? this.competencyDetailData : this.viewDetailData;
      
      // Handle new API format (competency_proficiency_standard array)
      if (detailData.competency_proficiency_standard && detailData.competency_proficiency_standard.length > 0) {
        return detailData.competency_proficiency_standard.map((item, index) => ({
          number: index + 1,
          position_id: item.position_id,
          position_title: item.position_title,
          proficiency: item.proficiency
        }));
      }
      
      // Handle positions array format
      if (detailData.positions && detailData.positions.length > 0) {
        return detailData.positions.map((item, index) => ({
          number: index + 1,
          position_id: item.position_id,
          position_title: this.getPositionName(item.position_id) || item.position_title,
          proficiency: item.proficiency || item.proficiency
        }));
      }
      
      // Handle legacy format (single position/proficiency)
      if (detailData.position || detailData.proficiency) {
        return [{
          number: 1,
          position_id: detailData.position,
          position_title: this.getPositionName(detailData.position),
          proficiency: detailData.proficiency || detailData.proficiency
        }];
      }
      
      // Return empty array if no data
      return [];
    },
    // Pagination computed properties
    totalPages() {
      return Math.ceil(this.totalItems / this.body.limit);
    },
    visiblePages() {
      const current = this.body.page;
      const total = this.totalPages;
      const delta = 2;
      const range = [];
      const left = Math.max(1, current - delta);
      const right = Math.min(total, current + delta);

      for (let i = left; i <= right; i++) {
        range.push(i);
      }

      return range;
    }
  },
  data() {
    return {
      imageBaseUrl: process.env.VUE_APP_API_URL_UGEMS_UNIV,
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },
      body: {
        page: 1,
        limit: 10,
        search: "",
        order: ""
      },
      filters: {
        object_type: "",
        search: ""
      },
      bodyAdd: {
        uniformLevel: false,
        competency_id: "",
        competency_name: "",
        description: "",
        object_type: "",
        parent_id: null,
        image: null,
        imagePreview: null,
        positions: [],
        proficiency1_description: "",
        proficiency2_description: "",
        proficiency3_description: "",
        proficiency4_description: "",
        proficiency5_description: ""
      },
      bodyUpdate: {
        uniformLevel: false,
        competency_id: "",
        competency_name: "",
        description: "",
        object_type: "",
        parent_id: null,
        image: null,
        imagePreview: null,
        positions: [],
        proficiency1_description: "",
        proficiency2_description: "",
        proficiency3_description: "",
        proficiency4_description: "",
        proficiency5_description: ""
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: "Add Competency",
      searchTimeout: null,
      // Upload related data
      selectedFile: null,
      isUploading: false,
      // Image crop status tracking
      imageCropStatusAdd: true, // true = no image or already cropped, false = needs crop
      imageCropStatusUpdate: true,
      editorToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['clean']
      ],
      columns: [
        {
          label: "ROLE COMPETENCY ID",
          field: "role_competency_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "12%"
        },
        {
          label: "ID",
          field: "id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "8%"
        },
        {
          label: "NAME",
          field: "name",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "25%"
        },
        {
          label: "OBJECT TYPE",
          field: "object_type",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "22%"
        },
        {
          label: "PARENT ID",
          field: "parent_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "10%"
        },
        // {
        //   label: "POSITION",
        //   field: "position",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "10%"
        // },
        // {
        //   label: "PROFICIENCY LEVEL",
        //   field: "proficiency",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "10%"
        // },
        {
          label: "ACTION",
          field: "action",
          thClass: "table-header no-wrap text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
          width: "13%"
        }
      ],
      positionProficiencyColumns: [
        {
          label: "#",
          field: "number",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle text-center",
          width: "10%"
        },
        {
          label: "POSITION ID",
          field: "position_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "20%"
        },
        {
          label: "POSITION TITLE",
          field: "position_title",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "50%"
        },
        {
          label: "PROFICIENCY LEVEL",
          field: "proficiency",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle text-center",
          width: "20%"
        }
      ]
    };
  },
  mounted() {
    // Load main data
    this.getCompetencies();
    
    // Set menu permissions
    this.setMenuPermissions();
  },
  methods: {
    // Imported utility functions
    formatDate,
    formatDateForInput,

    // Date validation helper
    isValidDate(dateString) {
      const date = new Date(dateString);
      return date instanceof Date && !isNaN(date);
    },

    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // Get position name
    getPositionName(positionId) {
      const position = this.positionOptions.find(p => p.id === positionId || p.position_id === positionId);
      return position ? (position.name || position.position_title) : positionId;
    },

    // Card layout helper methods
    getDummyThumbnail(competency) {
      // Create dummy thumbnails based on competency type and ID
      const thumbnails = [
        'https://images.unsplash.com/photo-1553484771-371a605b060b?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1565688534245-05d6b5be184a?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1606857521015-7f9fcf423740?w=300&h=200&fit=crop',
        'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=300&h=200&fit=crop'
      ];
      
      // Use competency ID to determine which thumbnail to use
      const index = competency.id ? (parseInt(competency.id) % thumbnails.length) : 0;
      return thumbnails[index];
    },

    getCompetencyTypeBadgeClass(objectType) {
      const baseClass = 'badge ';
      switch(objectType) {
        case 'Q':
          return baseClass + 'badge-primary';
        case 'QK':
          return baseClass + 'badge-success';
        default:
          return baseClass + 'badge-secondary';
      }
    },

    handleImageError(event) {
      // Fallback to a default image if the thumbnail fails to load
      event.target.src = 'https://dummyimage.com/300x200/FAFAFA/000000&text=Comp';
    },

    getRandomStats() {
      // Generate random statistics for the card footer
      const courses = Math.floor(Math.random() * 50) + 5; // 5-54 courses
      const users = Math.floor(Math.random() * 900) + 100; // 100-999 users
      return {
        courses,
        users
      };
    },



    // Image handling methods for Add form
    handleImageUploadAdd(event) {
      const file = event.target.files[0];
      if (file) {
        this.processImageAdd(file);
      }
    },

    handleImageDropAdd(event) {
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.processImageAdd(file);
      }
    },

    processImageAdd(file) {
      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        this.$swal("Error", "Ukuran file harus kurang dari 10MB", "error");
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.$swal("Error", "Pilih file gambar yang valid", "error");
        return;
      }

      this.bodyAdd.image = file;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.bodyAdd.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImageAdd() {
      this.bodyAdd.image = null;
      this.bodyAdd.imagePreview = null;
      if (this.$refs.imageInputAdd) {
        this.$refs.imageInputAdd.value = '';
      }
    },

    // Image handling methods for Update form
    handleImageUploadUpdate(event) {
      const file = event.target.files[0];
      if (file) {
        this.processImageUpdate(file);
      }
    },

    handleImageDropUpdate(event) {
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.processImageUpdate(file);
      }
    },

    processImageUpdate(file) {
      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        this.$swal("Error", "Ukuran file harus kurang dari 10MB", "error");
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.$swal("Error", "Pilih file gambar yang valid", "error");
        return;
      }

      this.bodyUpdate.image = file;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.bodyUpdate.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImageUpdate() {
      this.bodyUpdate.image = null;
      this.bodyUpdate.imagePreview = null;
      if (this.$refs.imageInputUpdate) {
        this.$refs.imageInputUpdate.value = '';
      }
    },

    // New cropper event handlers for Add form
    onImageCroppedAdd(result) {
      this.bodyAdd.image = result.file;
      this.bodyAdd.imagePreview = result.preview;
    },

    onImageRemovedAdd() {
      this.bodyAdd.image = null;
      this.bodyAdd.imagePreview = null;
    },

    onImageErrorAdd(error) {
      this.$swal("Error", error, "error");
    },

    onCropStatusChangeAdd(status) {
      // status: true = cropped, false = needs crop
      this.imageCropStatusAdd = status;
    },

    // New cropper event handlers for Update form
    onImageCroppedUpdate(result) {
      this.bodyUpdate.image = result.file;
      this.bodyUpdate.imagePreview = result.preview;
    },

    onImageRemovedUpdate() {
      this.bodyUpdate.image = null;
      this.bodyUpdate.imagePreview = null;
    },

    onImageErrorUpdate(error) {
      this.$swal("Error", error, "error");
    },

    onCropStatusChangeUpdate(status) {
      // status: true = cropped, false = needs crop
      this.imageCropStatusUpdate = status;
    },

    // Pagination methods
    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.body.page) {
        this.body.page = page;
        this.fetchData();
      }
    },

    onPerPageChange() {
      this.body.page = 1; // Reset to first page when changing per page
      this.fetchData();
    },

    // Update position title when position_id changes
    updatePositionTitle(item, selectedPositionId) {
      const selectedPosition = this.positionOptions.find(p => p.position_id === selectedPositionId);
      if (selectedPosition) {
        // Update both position_id and position_title
        item.position_id = selectedPositionId;
        item.position_title = selectedPosition.position_title || selectedPosition.name;
      }
    },

    // Search with debounce
    onSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.body.search = this.filters.search;
        this.body.page = 1;
        this.getCompetencies();
      }, 500);
    },

    // Clear all filters
    clearFilters() {
      this.filters = {
        object_type: "",
        search: ""
      };
      this.body.search = "";
      this.body.page = 1;
      this.getCompetencies();
    },

    // Actions
    addData() {
      this.isAdd = true;
      this.modalTitle = "Add Competency";
      this.resetAddForm();
      
      // Load dropdown options when modal opens
      this.loadDropdownOptions();
      
      this.$bvModal.show("modal-competency");
    },

    viewData(data) {
      this.isAdd = null; // View mode
      this.modalTitle = "View Competency";
      this.viewDetailData = {}; // Reset view data
      this.$bvModal.show("modal-competency");
      
      // Fetch detailed competency data from API
      this.getCompetencyDetail(data.id);
    },

    updateData(data) {
      this.isAdd = false;
      this.modalTitle = "Edit Competency";
      
      // Reset form data first
      this.resetUpdateForm();
      
      // Load dropdown options when modal opens
      this.loadDropdownOptions();
      
      // Show modal with loading state
      this.$bvModal.show("modal-competency");
      
      // Fetch detailed competency data from API
      this.getCompetencyDetailForEdit(data.id);
    },

    resetAddForm() {
      this.bodyAdd = {
        uniformLevel: false,
        competency_id: "",
        competency_name: "",
        description: "",
        object_type: "",
        parent_id: null,
        image: null,
        imagePreview: null,
        positions: [],
        proficiency1_description: "",
        proficiency2_description: "",
        proficiency3_description: "",
        proficiency4_description: "",
        proficiency5_description: ""
      };
      
      // Reset crop status
      this.imageCropStatusAdd = true;
      
      // Reset file input
      if (this.$refs.imageInputAdd) {
        this.$refs.imageInputAdd.value = '';
      }
      
      this.$validator.reset();
    },

    resetUpdateForm() {
      this.bodyUpdate = {
        id: "",
        uniformLevel: false,
        competency_id: "",
        competency_name: "",
        description: "",
        object_type: "",
        parent_id: null,
        image: null,
        imagePreview: null,
        positions: [
          {
            position_id: "",
            position_title: "",
            proficiency: 3
          }
        ],
        proficiency1_description: "",
        proficiency2_description: "",
        proficiency3_description: "",
        proficiency4_description: "",
        proficiency5_description: ""
      };
      
      // Reset crop status
      this.imageCropStatusUpdate = true;
      
      // Reset file input
      if (this.$refs.imageInputUpdate) {
        this.$refs.imageInputUpdate.value = '';
      }
      
      this.$validator.reset();
    },

    // Position Proficiency Methods
    addPositionProficiencyAdd() {
      this.bodyAdd.positions.push({
        position_id: "",
        position_title: "",
        proficiency: this.bodyAdd.uniformLevel ? 3 : 3
      });
    },

    removePositionProficiencyAdd(index) {
      this.bodyAdd.positions.splice(index, 1);
    },

    addPositionProficiencyUpdate() {
      this.bodyUpdate.positions.push({
        position_id: "",
        position_title: "",
        proficiency: this.bodyUpdate.uniformLevel ? 3 : 3
      });
    },

    removePositionProficiencyUpdate(index) {
      this.bodyUpdate.positions.splice(index, 1);
    },

    toggleUniformLevelAdd() {
      if (this.bodyAdd.uniformLevel) {
        // Set all proficiency levels to 3 when uniform is enabled
        this.bodyAdd.positions.forEach(item => {
          item.proficiency = 3;
        });
      }
    },

    toggleUniformLevelUpdate() {
      if (this.bodyUpdate.uniformLevel) {
        // Set all proficiency levels to 3 when uniform is enabled
        this.bodyUpdate.positions.forEach(item => {
          item.proficiency = 3;
        });
      }
    },

    // Save methods
    saveAdd() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        // Validate image crop status
        if (!this.imageCropStatusAdd) {
          this.$swal("Warning", "Potong gambar terlebih dahulu sebelum menyimpan", "warning");
          return false;
        }
        
        try {
          let transformedPositions;
          // Transform positions data to the expected format
          if (this.bodyAdd.positions.length > 0) {
            transformedPositions = this.bodyAdd.positions.map(pos => ({
              position_id: pos.position_id,
              position_title: pos.position_title,
              proficiency: new Number(pos.proficiency)
            })); 
          }

          // Create FormData object
          const formData = new FormData();
          
          // Add text fields
          formData.append('competency_id', this.bodyAdd.competency_id);
          formData.append('competency_name', this.bodyAdd.competency_name);
          formData.append('description', this.bodyAdd.description);
          formData.append('object_type', this.bodyAdd.object_type || '');
          
          // Only append parent_id if it has a value
          if (this.bodyAdd.parent_id) {
            formData.append('parent_id', this.bodyAdd.parent_id);
          }
          
          formData.append('start_date', "2023-01-01");
          formData.append('end_date', "9999-12-31");
          
          // Add positions as JSON string
          if (this.bodyAdd.positions.length > 0) {
            formData.append('positions', JSON.stringify(transformedPositions));
          }
          
          // Add proficiency descriptions
          formData.append('proficiency1_description', this.bodyAdd.proficiency1_description || '');
          formData.append('proficiency2_description', this.bodyAdd.proficiency2_description || '');
          formData.append('proficiency3_description', this.bodyAdd.proficiency3_description || '');
          formData.append('proficiency4_description', this.bodyAdd.proficiency4_description || '');
          formData.append('proficiency5_description', this.bodyAdd.proficiency5_description || '');
          
          // Add image file if present
          if (this.bodyAdd.image) {
            formData.append('image', this.bodyAdd.image);
          }
          
          await this.$store.dispatch("competency/createCompetency", formData);
          this.$swal({
            title: "Success",
            text: "Competency berhasil ditambahkan",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getCompetencies();
            this.$bvModal.hide("modal-competency");
            this.resetAddForm();
          });
        } catch (error) {
          console.log("Error response:", error);
          let errorMessage = "Error while adding competency";
          
          // Handle API error response
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    saveUpdate() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        // Validate image crop status
        if (!this.imageCropStatusUpdate) {
          this.$swal("Warning", "Potong gambar terlebih dahulu sebelum menyimpan", "warning");
          return false;
        }
        
        try {
          // Transform positions data to the expected format
          const transformedPositions = this.bodyUpdate.positions.map(pos => ({
            position_id: pos.position_id,
            position_title: pos.position_title,
            proficiency: new Number(pos.proficiency)
          }));

          // Create FormData object
          const formData = new FormData();
          
          // Add text fields
          formData.append('competency_id', this.bodyUpdate.competency_id);
          formData.append('competency_name', this.bodyUpdate.competency_name);
          formData.append('description', this.bodyUpdate.description);
          formData.append('object_type', this.bodyUpdate.object_type || '');
          
          // Only append parent_id if it has a value
          if (this.bodyUpdate.parent_id) {
            formData.append('parent_id', this.bodyUpdate.parent_id);
          }
          
          formData.append('start_date', "2023-01-01");
          formData.append('end_date', "9999-12-31");
          
          // Add positions as JSON string
          if (this.bodyUpdate.positions.length > 0) {
            formData.append('positions', JSON.stringify(transformedPositions));
          }
          
          // Add proficiency descriptions
          formData.append('proficiency1_description', this.bodyUpdate.proficiency1_description || '');
          formData.append('proficiency2_description', this.bodyUpdate.proficiency2_description || '');
          formData.append('proficiency3_description', this.bodyUpdate.proficiency3_description || '');
          formData.append('proficiency4_description', this.bodyUpdate.proficiency4_description || '');
          formData.append('proficiency5_description', this.bodyUpdate.proficiency5_description || '');
          
          // Add image file if present
          if (this.bodyUpdate.image) {
            formData.append('image', this.bodyUpdate.image);
          }

          await this.$store.dispatch("competency/updateCompetency", {
            id: this.bodyUpdate.id, // Use the original ID for the API call
            data: formData
          });
          
          this.$swal({
            title: "Success",
            text: "Competency berhasil diperbarui",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getCompetencies();
            this.$bvModal.hide("modal-competency");
          });
        } catch (error) {
          console.log("Error response:", error);
          let errorMessage = "Error while updating competency";
          
          // Handle API error response
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    deleteData(id) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$store.dispatch("competency/deleteCompetency", id);
            this.getCompetencies();
            this.$swal("Terhapus", "Competency telah dihapus", "success");
          } catch (error) {
            this.$swal("Error", "Gagal menghapus competency", "error");
          }
        }
      });
    },

    // API calls
    getCompetencies() {
      const params = { ...this.body };
      if (this.filters.object_type) params.object_type = this.filters.object_type;
      if (this.filters.search) params.search = this.filters.search;
      
      this.$store.dispatch("competency/getCompetencies", params);
    },

    // Load all dropdown options for modal create/edit
    loadDropdownOptions() {
      this.getAllCompetencyOptions();
      this.getPositions();
      this.getRoleCompetencies();
    },

    getAllCompetencyOptions() {
      this.$store.dispatch("competencyOptions/getAllCompetencies");
    },

    getPositions() {
      this.$store.dispatch("position/getPositions", {
        limit: 100
      });
    },

    getRoleCompetencies() {
      this.$store.dispatch("roleCompetency/getRoleCompetencies", {
        limit: 100
      });
    },

    async getCompetencyDetail(id) {
      try {
        const competencyDetail = await this.$store.dispatch("competency/getCompetencyById", id);
        this.viewDetailData = competencyDetail;
      } catch (error) {
        console.error('Error fetching competency detail:', error);
        this.$swal("Error", "Detail competency belum berhasil dimuat", "error");
      }
    },

    async getCompetencyDetailForEdit(id) {
      try {
        const competencyDetail = await this.$store.dispatch("competency/getCompetencyById", id);
        
        // Populate bodyUpdate with API data
        this.bodyUpdate.id = competencyDetail.id;
        this.bodyUpdate.competency_id = competencyDetail.id; // Using id as competency_id
        this.bodyUpdate.competency_name = competencyDetail.name;
        this.bodyUpdate.description = competencyDetail.description;
        this.bodyUpdate.object_type = competencyDetail.object_type;
        this.bodyUpdate.parent_id = competencyDetail.parent_id || null;
        
        // Load existing image if available
        if (competencyDetail.image_url || competencyDetail.thumbnail_url) {
          const imageUrl = competencyDetail.image_url || competencyDetail.thumbnail_url;
          this.bodyUpdate.imagePreview = `${this.imageBaseUrl}/attachments/${imageUrl}`;
        }
        
        // Handle positions from competency_proficiency_standard
        if (competencyDetail.competency_proficiency_standard && competencyDetail.competency_proficiency_standard.length > 0) {
          this.bodyUpdate.positions = competencyDetail.competency_proficiency_standard.map(item => ({
            position_id: item.position_id,
            position_title: item.position_title,
            proficiency: item.proficiency || 3
          }));
        } else {
          // Default to empty position if no data
          this.bodyUpdate.positions = [];
        }
        
        // Handle proficiency descriptions
        this.bodyUpdate.proficiency1_description = competencyDetail.proficiency1_description || "";
        this.bodyUpdate.proficiency2_description = competencyDetail.proficiency2_description || "";
        this.bodyUpdate.proficiency3_description = competencyDetail.proficiency3_description || "";
        this.bodyUpdate.proficiency4_description = competencyDetail.proficiency4_description || "";
        this.bodyUpdate.proficiency5_description = competencyDetail.proficiency5_description || "";
        
        this.bodyUpdate.uniformLevel = false;
        
      } catch (error) {
        console.error('Error fetching competency detail for edit:', error);
        this.$swal("Error", "Detail competency untuk diedit belum berhasil dimuat", "error");
        this.$bvModal.hide("modal-competency");
      }
    },

    // Upload Methods
    showUploadModal() {
      this.selectedFile = null;
      this.isUploading = false;
      this.$bvModal.show("modal-upload");
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        this.selectedFile = null;
        return;
      }

      // Validate file type
      if (!file.name.toLowerCase().endsWith('.xlsx')) {
        this.$swal("Error", "Pilih file Excel yang valid (.xlsx)", "error");
        this.clearFile();
        return;
      }

      // Validate file size (max 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        this.$swal("Error", "Ukuran file harus kurang dari 5MB", "error");
        this.clearFile();
        return;
      }

      this.selectedFile = file;
    },

    clearFile() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    async downloadTemplate() {
      try {
        const response = await this.$store.dispatch("competency/downloadCompetencyTemplate");
        
        // Create download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'competency_template.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        
        this.$swal("Success", "Template berhasil diunduh", "success");
      } catch (error) {
        console.error('Error downloading template:', error);
        this.$swal("Error", "Template belum berhasil diunduh", "error");
      }
    },

    async uploadFile() {
      if (!this.selectedFile) {
        this.$swal("Error", "Pilih file yang akan diunggah", "error");
        return;
      }

      this.isUploading = true;
      
      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);

        const response = await this.$store.dispatch("competency/uploadCompetencyFile", formData);
        
        // Check if response has data
        if (response && response.data) {
          const { importedCompetencies = 0, importedPositions = 0, errorsData = 0, errors = [] } = response.data;
          
          // If there are errors, show error message with table
          if (errorsData > 0 && errors.length > 0) {
            let errorTableHtml = `
              <div class="mb-3 text-left">
                <p><strong>Import Summary:</strong></p>
                <ul>
                  <li>Imported Competencies: ${importedCompetencies}</li>
                  <li>Imported Positions: ${importedPositions}</li>
                  <li>Errors Found: ${errorsData}</li>
                </ul>
              </div>
              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <thead class="table-danger">
                    <tr>
                      <th>Line</th>
                      <th>Column</th>
                      <th>Error Message</th>
                    </tr>
                  </thead>
                  <tbody>
            `;
            
            errors.forEach(error => {
              errorTableHtml += `
                <tr>
                  <td>${error.line || '-'}</td>
                  <td>${error.column || '-'}</td>
                  <td>${error.message || 'Unknown error'}</td>
                </tr>
              `;
            });
            
            errorTableHtml += `
                  </tbody>
                </table>
              </div>
            `;
            
            this.$swal({
              title: "Unggah Selesai dengan Error",
              html: errorTableHtml,
              icon: "warning",
              confirmButtonText: "OK",
              width: '600px'
            }).then(() => {
              this.getCompetencies(); // Refresh data table
              this.$bvModal.hide("modal-upload");
              this.clearFile();
            });
          } 
          // If no errors, show success message
          else {
            this.$swal({
              title: "Unggah Berhasil",
              html: `
                <div class="text-left">
                  <p><strong>Import Summary:</strong></p>
                  <ul>
                    <li>Imported Competencies: ${importedCompetencies}</li>
                    <li>Imported Positions: ${importedPositions}</li>
                    <li>Errors: ${errorsData}</li>
                  </ul>
                </div>
              `,
              icon: "success",
              confirmButtonText: "OK"
            }).then(() => {
              this.getCompetencies(); // Refresh data table
              this.$bvModal.hide("modal-upload");
              this.clearFile();
            });
          }
        } else {
          // Fallback for unexpected response format
          this.$swal({
            title: "Success",
            text: "File berhasil diunggah",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getCompetencies();
            this.$bvModal.hide("modal-upload");
            this.clearFile();
          });
        }

      } catch (error) {
        console.error('Error uploading file:', error);
        let errorMessage = "Error while uploading file";
        
        // Handle API error response
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          }
        }
        
        this.$swal("Error", errorMessage, "error");
      } finally {
        this.isUploading = false;
      }
    },

    // Legacy pagination method (kept for compatibility)
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getCompetencies();
    },

    // Fetch data method to consolidate data fetching
    fetchData() {
      this.getCompetencies();
    }
  }
};